"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const TabRegionsIcon_1 = __importDefault(require("../../atoms/TabRegionsIcon"));
function Tab(props) {
    const { index, selected = false, title, subtitle, canBeClosed = true, onClick, onClose, } = props;
    return ((0, jsx_runtime_1.jsxs)(Container, { "$selected": selected, children: [(0, jsx_runtime_1.jsxs)(Button, { onClick: () => onClick(index), children: [(0, jsx_runtime_1.jsx)(RegionsIcon, { height: 24 }), (0, jsx_runtime_1.jsxs)(TextContainer, { children: [(0, jsx_runtime_1.jsx)(Title, { children: `${index + 1}. ${title}` }), (0, jsx_runtime_1.jsx)(Subtitle, { children: subtitle })] })] }), canBeClosed && ((0, jsx_runtime_1.jsx)(CloseButton, { onClick: () => onClose(index), children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Cross, width: 16, height: 16 }) }))] }));
}
exports.default = Tab;
const Container = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 200px;
  height: 44px;

  background-color: ${props => props.$selected
    ? props.theme.tabs.tab.color2
    : props.theme.tabs.tab.color1};
  border-right: 1px solid ${props => props.theme.tabs.tab.color2};
  border-bottom: 1px solid
    ${props => (props.$selected ? props.theme.green : 'transparent')};
`;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: inline-flex;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;
const RegionsIcon = (0, styled_components_1.default)(TabRegionsIcon_1.default) `
  flex-shrink: 0;

  width: 25px;

  margin: auto 10px;

  color: ${props => props.theme.text};
`;
const TextContainer = styled_components_1.default.div `
  margin: auto 0;
  overflow: hidden;
`;
const Text = (0, styled_components_1.default)(ui_1.TruncatedText) `
  text-align: left;
`;
const Title = (0, styled_components_1.default)(Text) `
  color: ${props => props.theme.textSecondary};
  font-weight: 400;
  font-size: 10px;
`;
const Subtitle = (0, styled_components_1.default)(Text) `
  padding: 1px 0 0 0;

  color: ${props => props.theme.text};
  font-size: 12px;
`;
const CloseButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: inline-flex;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: auto 10px;
  padding: 0;

  color: ${props => props.theme.gray};
`;
